export default {
  state: {
    endPointConfig: ''
  }
}
